var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6418 1.3125H12.5723L8.35586 6.13047L13.316 12.6875H9.4332L6.38984 8.71172L2.91172 12.6875H0.978516L5.4875 7.5332L0.732422 1.3125H4.71367L7.46172 4.94648L10.6418 1.3125ZM9.96367 11.5336H11.0328L4.13125 2.40625H2.98281L9.96367 11.5336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXFilled);
export default __webpack_public_path__ + "static/media/x-filled.854bf2e811b289e060df7758a9330b4d.svg";
export { ForwardRef as ReactComponent };